<template>
  <div>
    <!-- <div class="handle-box"> -->
    <div class="info_box_title">
      <p class="line"></p>
      <p class="info_title">农场维度的药品用量明细</p>
    </div>
    <el-row style="margin-top:10px;">
      <el-button v-acl="RMC_PROT_MEDUSAGE_ITEM_UPDATE" class="btn" type="primary" @click="onDownload">导出</el-button>
    </el-row>
    <el-table :data="tableData" style="width: 100%;margin-top:8px;" border>
      <el-table-column prop="farmName" label="农场名称" width="100"> </el-table-column>
      <el-table-column prop="farmBreedingMode" label="养殖模式" width="100"></el-table-column>
      <el-table-column prop="cropQty" label="鸡群数量(只)" width="100"> </el-table-column>
      <el-table-column prop="avgWeight" label="鸡群平均体重" width="120"> </el-table-column>
      <el-table-column prop="avgWeightUom" label="平均体重单位" width="100">
        <template slot-scope="scope">{{scope.row.avgWeightUom | avgWeightUomFilter}}</template>
      </el-table-column>
      <el-table-column prop="cropWeight" label="麦当劳农场出栏量(重量,kg)" width="160"></el-table-column>
      <el-table-column prop="totalNetUsage" label="原粉量" width="90"></el-table-column>
      <el-table-column prop="antibioticsUsage" label="抗生素用量(mg/kg)(原粉量/出栏总重量)" width="220"></el-table-column>
      <el-table-column prop="hpciaAntibioticsUsage" label="HPCIA类抗生素使用量(mg/kg)(HPCIA抗生素原粉量/出栏总重量)" width="360"></el-table-column>
      <el-table-column prop="usageIn7Day" label="前7日抗生素使用量" width="150"></el-table-column>
    </el-table>
  </div>
  <!-- </div> -->
</template>
<script>
import { fileService } from "@/api/common/file-utils";
import medicineDosage from "@/api/rmcProtein/medicineDosage";
export default {
  name: 'McdSrmVueEchart',
  props: ['ttRmcProteinMedicineUsageId'],
  filters: {
    avgWeightUomFilter(val) {
      if (val == 'KG') {
        return '公斤'
      } else if (val == "POUND") {
        return "磅"
      }
    }
  },
  data() {
    return {
      tableData: [],
      id:""
    };
  },

  mounted() {

  },
  watch: {
    ttRmcProteinMedicineUsageId: {
      handler(newv) {
        console.log("GY🚀 ~ file: echart.vue:42 ~ handler ~ newv:", newv);
        if (newv) {
          this.id=newv
          this.getSummaryEchart(newv)
        }
      },
      immediate: true
    }
  },
  methods: {
    getSummaryEchart(id) {
      medicineDosage.getSummaryEchart(id).then(res => {
        console.log("GY🚀 ~ file: echart.vue:43 ~ medicineDosage.getSummaryEchart ~ res:", res);
        this.tableData = res.data
      })
    },
    onDownload() {
      medicineDosage.downloadFile(this.id).then(res => {
        fileService.respToFile(res);
      })
    }
  },
};
</script>
<style scoped>
.info_box_title {
  width: calc(100% - 10px);
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
  padding-left: 10px;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
}
.info_title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  margin-left: 5px;
}
</style>